import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

class Review extends Component {
	render() {
		return (
			<div>
				<section className="is-fullheight section review" id="review" name="scroll-to-review">
					<div className="container">
						<div className="content has-text-centered">
							<Fade left>
								<h2 className="title is-uppercase">About us</h2>
								<p className="subtitle">Kenali kami lebih jauh</p>
							</Fade>
						</div>
						<div className="columns is-flex is-vcentered">
							<div className="column is-5">
								<Fade left>
									<h4 className="title">Fast</h4>
									<p className="subtitle">
										Para driver yang terpercaya dan berkendaran dengan nyaman dan aman menjadi salah
										satu poin utama kami
									</p>
									<a href="blog.deliv.co.id" className="button btn-blue is-rounded is-medium">
										Readmore <i className="fas fa-arrow-right" />{' '}
									</a>
								</Fade>
							</div>
							<div className="column is-6 is-offset-1">
								<Fade left>
									<figure className="image">
										<img
											src="/img/about/anak-sekolah.JPG"
											alt="De Ride Armada Deliv"
											className="review_img_right"
										/>
									</figure>
								</Fade>
							</div>
						</div>
						<div className="columns is-flex is-vcentered">
							<div className="column is-6 ">
								<Fade left>
									<figure className="image">
										<img
											src="/img/about/de-express.JPG"
											alt="De Ride Armada Deliv"
											className="review_img_left"
										/>
									</figure>
								</Fade>
							</div>
							<div className="column is-5 is-offset-1">
								<Fade left>
									<h4 className="title">Trust</h4>
									<p className="subtitle">
										Para driver yang terpercaya dan berkendaran dengan nyaman dan aman menjadi salah
										satu poin utama kami
									</p>
									<a href="blog.deliv.co.id" className="button btn-blue is-rounded is-medium">
										{' '}
										Readmore <i className="fas fa-arrow-right" />{' '}
									</a>
								</Fade>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default Review;
